export const NumberFormatter = {
  round
}

function round (value) {
  return Math.round(parseFloat(value)).toLocaleString('sv-SE')
}
